import { makeStyles } from '@mui/styles';
import { transactionTypeMap } from '@tassat/common-definitions';
import React from 'react';

interface PledgeTransactionActionConversion {
    value: any;
    isAdmin: boolean;
}

const muiStyles = makeStyles(() => ({ cellStyle: { textTransform: 'capitalize' }}));

export const PledgeTransactionActionConversion = ({ value }: PledgeTransactionActionConversion) => {
    const styles = muiStyles();
    const tranType = transactionTypeMap(value);

    return (
        <span className={styles.cellStyle}>{tranType}</span>
    );
};